import React from 'react';
import { RouteComponentProps, Redirect } from 'react-router';
import './CreateSuggestion.css';
import { User } from '../../App';
import { SuggestionStats } from './Models';

interface State {
    title: string;
    description: string;
}

interface Props {
    onCreateSuggestion: (title: string, description: string) => void;
    user: User | null;
    stats: SuggestionStats;
}

export default class CreateSuggestion extends React.Component<Props & RouteComponentProps, State> {
    constructor(props: Props & RouteComponentProps) {
        super(props);
        this.state = {
            title: '',
            description: ''
        };

        this.handleDescription = this.handleDescription.bind(this);
        this.handleTitle = this.handleTitle.bind(this);
    }
    handleDescription(event: React.ChangeEvent<HTMLTextAreaElement>) {
        const val = event.target.value || '';
        this.setState((prev) => ({
            ...prev,
            description: val
        }));
    }

    handleTitle(event: React.ChangeEvent<HTMLInputElement>) {
        const val = event.target.value || '';
        this.setState((prev) => ({
            ...prev,
            title: val
        }));
    }

    addSuggestion() {
        this.props.onCreateSuggestion(this.state.title, this.state.description);
    }

    reset() {
        this.setState({
            title: '',
            description: ''
        });
    }

    isValidTitle(){
        return this.state.title.length >= 10 
            && this.state.title.length <= 100;
    }

    isValidDesc(){
        return this.state.description.length > 0
            && this.state.description.length < 1024;
    }

    isValid() {
        return this.isValidDesc() && this.isValidTitle();
    }

    render() {
        if (this.props.user == null) {
            return <Redirect to="/" />;
        }

        return (
            <div className="new-suggestion">
                <div className="new-suggestion__header">
                    <span className="new-suggestion__title">Create a new suggestion</span>
                </div>
                <hr />
                <form className="new-suggestion__form">
                    <div className="form-group">
                        <label>Title</label>
                        <input
                            type="text"
                            placeholder="Give a concise and straightforward title for your suggestion."
                            onChange={this.handleTitle}
                            value={this.state.title} />
                            <div className={"char-count " + (this.isValidTitle() ? "green" : "red")}>
                                {
                                    this.state.title.length < 10
                                        ? this.state.title.length + " / 10"
                                        : this.state.title.length + " / 100"
                                }
                            </div>
                    </div>
                    <div className="form-group">
                        <label>Description</label>
                        <textarea
                            id=""
                            name=""
                            cols={30}
                            rows={10}
                            placeholder="Describe your suggestion in detail, preferably with examples of how it'll work. Markdown is supported here."
                            onChange={this.handleDescription}
                            value={this.state.description} />
                            <div className={"char-count " + (this.isValidDesc() ? "green" : "red")}>
                                {this.state.description.length} / 1024
                            </div>
                    </div>
                    <div className="new-suggestion__actions">
                        <button type="button"
                            className={"button " + (this.isValid() ? "button--blue" : "button--red")}
                            disabled={this.state.title.trim().length < 10}
                            onClick={() => this.addSuggestion()}>
                            <span>Create</span>
                            <div className="icon">
                                <svg style={({ width: '24px', height: '24px' })} viewBox="0 0 24 24">
                                    <path fill="#000000" d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
                                </svg>
                            </div>
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}